"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduceToChunks;
function reduceToChunks(array, chunkSize) {
  return array.reduce(function (accumulator, currentValue, currentIndex) {
    var ix = Math.floor(currentIndex / chunkSize);
    var newAccumulator = [].concat(accumulator);

    if (!newAccumulator[ix]) {
      newAccumulator[ix] = [];
    }

    newAccumulator[ix].push(currentValue);

    return newAccumulator;
  }, []);
}